import React, { useState } from "react";
import { Button, Dropdown, DropdownButton } from "react-bootstrap";
import { BsFillArrowLeftCircleFill, BsFillArrowRightCircleFill } from "react-icons/bs";
const Pagination = ({ paginationMeta, handlePagination, perPageCount, setPerPageCount }) => {
    var _a;
    const [goToPageNumber, setGoToPageNumber] = useState("");
    const totalAvailablePages = Math.ceil(((_a = paginationMeta === null || paginationMeta === void 0 ? void 0 : paginationMeta.totalNumRecords) !== null && _a !== void 0 ? _a : 0) / (perPageCount || 1));
    const goToPageInputHandler = (event) => {
        const inputString = event.target.value;
        if (!inputString) {
            setGoToPageNumber(inputString);
            return;
        }
        const isNumber = /^\d+$/.test(inputString);
        if (!isNumber)
            return;
        const pageNum = parseInt(inputString);
        if (pageNum > 0 && pageNum <= totalAvailablePages)
            setGoToPageNumber(inputString);
    };
    return (React.createElement("div", { className: "pagination-div d-flex justify-content-between align-items-center mt-3 mb-2" },
        React.createElement("div", { className: "page-number" },
            React.createElement("div", { className: "d-inline" },
                React.createElement(BsFillArrowLeftCircleFill, { title: "Previous page", size: 30, className: `me-2 arrow-left ${paginationMeta.pageNum <= 1 && "cursor-disable"}`, onClick: () => {
                        if (paginationMeta.pageNum > 1)
                            handlePagination([], { pageNum: paginationMeta.pageNum - 1, numRecords: perPageCount || 10 });
                    } }),
                React.createElement("div", { className: "d-inline-block mx-1 border rounded px-2 py-1 text-muted" }, !Number.isNaN(totalAvailablePages) &&
                    React.createElement(React.Fragment, null,
                        paginationMeta.pageNum,
                        " of ",
                        totalAvailablePages || 1)),
                React.createElement(BsFillArrowRightCircleFill, { title: "Next page", size: 30, className: `ms-2 arrow-right ${paginationMeta.pageNum >= totalAvailablePages && "cursor-disable"}`, onClick: () => {
                        if (paginationMeta.hasMoreRecords && paginationMeta.pageNum < totalAvailablePages)
                            handlePagination([], { pageNum: paginationMeta.pageNum + 1, numRecords: perPageCount || 10 });
                    } })),
            React.createElement("div", { className: "d-inline-flex align-items-center ms-3" },
                React.createElement("span", { className: "ms-1" },
                    " ",
                    React.createElement("b", null, "Go to:"),
                    " "),
                React.createElement("input", { type: "text", className: "d-inline-flex go-to-page-input ps-1 py-0 mx-3", value: goToPageNumber, onChange: goToPageInputHandler }),
                React.createElement(Button, { size: "sm", variant: "primary", title: `Go to page number ${goToPageNumber}`, onClick: () => {
                        const targetPageNum = Number.isNaN(goToPageNumber) ? -1 : parseInt(goToPageNumber);
                        if (targetPageNum > 0 && !Number.isNaN(totalAvailablePages) && targetPageNum <= totalAvailablePages) {
                            handlePagination([], { pageNum: targetPageNum, numRecords: perPageCount || 10 });
                        }
                    } },
                    React.createElement("b", null, "Go")))),
        React.createElement("div", { className: "d-flex justify-content-center align-items-center per-page-count" },
            React.createElement("span", { className: "me-1 text-nowrap" },
                React.createElement("b", null, "Entries per page:")),
            React.createElement(DropdownButton, { variant: "primary", size: "sm", id: "dropdown-basic-button", title: perPageCount || 10 }, [10, 20, 30].map((perPagePossibleValue, index) => {
                return (React.createElement(Dropdown.Item, { key: index, value: perPagePossibleValue, href: "#", onClick: () => {
                        setPerPageCount((prev) => perPagePossibleValue);
                        handlePagination([], { pageNum: paginationMeta.pageNum, numRecords: perPagePossibleValue });
                    } }, perPagePossibleValue));
            })))));
};
export default Pagination;
